import Icon from 'antd/lib/icon';
import './antd.css';
import 'antd/lib/icon/style/css';

export default Icon;
